<template lang="pug">
.swiper-container
  .swiper-wrapper
    .swiper-slide.match-marketgroup-content(:class="(source.marketId == 3) ? 'live' : ''")
      .match-bet-area-group.flex-grow-2
        hdpItem(:details="details" :oddsType="oddsType" betType="hdp" homeAway="1")
      .match-bet-area-group.flex-grow-2
        ouItem(:details="details" :oddsType="oddsType" betType="ou")
      .match-bet-area-group.flex-grow-1
        oxtItem(:details="details" :oddsType="oddsType" betType="oxt")
</template>

<script>
import hdpItem from "@/components/mobile/main/xitem/hdpItem";
import ouItem from "@/components/mobile/main/xitem/ouItem";
import oxtItem from "@/components/mobile/main/xitem/oxtItem";
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";

export default {
  components: {
    hdpItem,
    ouItem,
    oxtItem
  },
  mixins: [mixinHDPOUOdds],
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {}
};
</script>
